/**
 * Inserta un elemento en una posición específica de un arreglo.
 * Si la posición es mayor al tamaño del arreglo, lo agrega al final.
 * No modifica el arreglo original, retorna uno nuevo.
 * @param {Array} arr - Arreglo base
 * @param {number} position - Índice donde insertar (0-based)
 * @param {*} value - Valor a insertar
 * @returns {Array} Nuevo arreglo con el valor insertado
 */
export function insertAtPosition(arr, position, value) {
  const newArr = arr.slice()
  let idx = position
  if (idx < 0) {
    idx = Math.max(newArr.length + idx, 0)
  }
  if (idx >= newArr.length) {
    newArr.push(value)
  } else {
    newArr.splice(idx, 0, value)
  }
  return newArr
}
